module.exports = __webpack_public_path__ + "img/joyvill-logo-w 1.f53a5edf.png";